import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  withArrow?: boolean;
  fullWidth?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  withArrow = false,
  fullWidth = false,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold transition-all duration-300 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed uppercase tracking-wider';
  const variants = {
    primary: 'bg-gold hover:bg-gold-dark text-white shadow-lg hover:shadow-xl hover:-translate-y-0.5 focus:ring-gold',
    secondary: 'bg-sage hover:bg-sage-light text-white shadow-md focus:ring-sage',
    outline: 'border-2 border-sage text-sage hover:bg-sage/5 focus:ring-sage'
  };
  const sizes = {
    sm: 'px-4 py-2 text-xs',
    md: 'px-6 py-3 text-sm',
    lg: 'px-8 py-4 text-base',
    xl: 'px-10 py-5 text-lg'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`} {...props} data-id="element-502">
      {children}
      {withArrow && <ArrowRight className="ml-2 h-5 w-5" data-id="element-503" />}
    </button>;
}